import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Seo from "../components/site/Seo";
import { PageHero, Section, Disclaimer } from "../components/site/Bits";
import DynamicForm from "../components/forms/DynamicForm";
import { api } from "../lib/api";

export default function RequestTrial() {
  const [params] = useSearchParams();
  const slug = params.get("item");
  const { data: p, isLoading } = useQuery({
    queryKey: ["product", slug], enabled: !!slug, retry: false,
    queryFn: () => api.get(`/public/products/${slug}`).then((r) => r.data),
  });
  return (
    <>
      <Seo title="Request an Equipment Trial" path="/request-trial" description="Request an NDIS assistive technology trial at home in Melbourne or Victoria. Try equipment before you buy." />
      <PageHero eyebrow="Request a trial" title="Request an equipment trial"
        intro="Tell us a little about the participant and the equipment you're interested in. We'll confirm needs with the treating therapist before arranging delivery." />
      <Section>
        <div className="max-w-4xl">
          {slug && isLoading ? <p role="status">Loading…</p> : (
            <DynamicForm key={p?.id || "blank"} kind="trial" testid="trial-form" initial={p ? { equipment: p.name, product_id: p.id } : {}} />
          )}
          <div className="mt-8"><Disclaimer /></div>
        </div>
      </Section>
    </>
  );
}
